import "./Accordion.scss";

import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";

import RichTextBlock from "../rich-text-block/RichTextBlock";

export type AccordionProps = {
  content: string;
  title: string;
  showExpanded: boolean;
};

const AccordionComponent: React.FC<AccordionProps> = ({ content, title, showExpanded }: AccordionProps) => {
  const [expanded, setExpanded] = useState<boolean>(showExpanded);

  const handleAccordionClick = () => setExpanded((expanded) => !expanded);

  return (
    <Accordion expanded={expanded} onChange={handleAccordionClick} elevation={1}>
      <AccordionSummary className="header" expandIcon={<ExpandMoreIcon />} >
        <Typography variant='h6'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <RichTextBlock content={content} />
      </AccordionDetails>
    </Accordion>
  );
};
export default AccordionComponent;
